import { render, staticRenderFns } from "./rankingChart.vue?vue&type=template&id=027a10ca&scoped=true&"
import script from "./rankingChart.vue?vue&type=script&lang=js&"
export * from "./rankingChart.vue?vue&type=script&lang=js&"
import style0 from "./rankingChart.vue?vue&type=style&index=0&id=027a10ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a10ca",
  null
  
)

export default component.exports